import { trigger, transition, style, animate } from '@angular/animations';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { delay } from 'rxjs/operators';
import SmoothScrollbar from 'smooth-scrollbar';
import { ScrollStatus } from 'smooth-scrollbar/interfaces';
import { MenuItem } from '../navigation/navigation.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToolTipMenuComponent } from '../../shares/tooltip-menu/tooltip-menu.component';
@Component({
  selector: 'app-nav-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
  animations: [
    trigger('subItem', [
      transition(':enter', [
        style({ transform: 'translateX(-50px)', opacity: 0, height: 0 }),
        animate(
          '.2s ease',
          style({ transform: 'translateX(0px)', opacity: 1, height: '*' })
        ),
      ]),
      transition(':leave', [
        animate(
          '.2s ease',
          style({ transform: 'translateX(-50px)', opacity: 0, height: 0 })
        ),
      ]),
    ]),
  ],
})
export class NavMenuComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() isMenuIcon?: boolean;
  @Input() isHandset?: boolean;
  @Input() isTablet?: boolean;
  @Input() menu: MenuItem[] = new Array();
  @Output() menuClick: EventEmitter<void> = new EventEmitter();
  @Output() scrollbar: EventEmitter<ScrollStatus> = new EventEmitter();
  dialogRef: MatDialogRef<ToolTipMenuComponent> | null = null;

  constructor(
    private el: ElementRef,
    private _ngZone: NgZone,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private translateService: TranslateService
  ) {
    this.cd.detach();
    this.translateService.onLangChange.pipe(delay(0)).subscribe(() => {
      this.cd.detectChanges();
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isMenuIcon && changes.isMenuIcon.currentValue) {
      this.cd.reattach();
    } else {
      this.cd.detach();
    }
    if (changes.menu) {
      this.cd.detectChanges();
    }
    if (changes.isMenuIcon || changes.isTablet || changes.isHandset) {
      this.cd.detectChanges();
    }
  }

  onClickMenu(): void {
    this.menuClick.emit();
  }

  ngAfterViewInit(): void {
    this._ngZone
      .runOutsideAngular(() => SmoothScrollbar.init(this.el.nativeElement))
      .addListener((e) => {
        this.scrollbar.emit(e);
      });
  }

  toggleExpendMenu(menu: MenuItem): void {
    if(menu.expanded){
      menu.expanded = !menu.expanded;
    } else{
      this.menu.forEach((item) => {
      if (item === menu) {
        item.expanded = !item.expanded;}
      else {
        item.expanded = false;
      }})
    }
    
      this.cd.detectChanges();
  }

  openToolTip(titleKey: string, event: MouseEvent, toolTip: any): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.translateService.get(titleKey).subscribe((translatedTitle: string) => {
      const lengthWithoutSpaces = translatedTitle.replace(/\s+/g, '').length;
      const currentLang = this.translateService.currentLang;
      if (currentLang === 'km' && toolTip) {
        this.dialogRef = this.dialog.open(ToolTipMenuComponent, {
          data: { title: translatedTitle },
          panelClass: 'tooltip-dialog',
          hasBackdrop: false,
          position: {
            top: `${event.clientY + 10}px`,
            left: `${event.clientX + 10}px`,
          },
        });
      } else if (currentLang === 'en' && toolTip && lengthWithoutSpaces >= 28) {
        this.dialogRef = this.dialog.open(ToolTipMenuComponent, {
          data: { title: translatedTitle },
          panelClass: 'tooltip-dialog',
          hasBackdrop: false,
          position: {
            top: `${event.clientY + 10}px`,
            left: `${event.clientX + 10}px`,
          },
        });
      }
    });
  }

  closeToolTip(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
}
